/** Firestore collection for admin splat definition documents (name, limits, image, etc.). */
export const SPLAT_DEFINITIONS_COLLECTION = 'splatDefinitions';

/**
 * Firestore collection for metric definition documents (key, name, image, helpText, etc.).
 * Deploy Firestore rules for this path and Storage rules for the `metrics/` prefix.
 */
export const METRIC_DEFINITIONS_COLLECTION = 'metricDefinitions';

/**
 * Firestore collection for event definition documents (name, image, dates, etc.).
 * Deploy Firestore rules for this path and Storage rules for the `events/` prefix (default bucket).
 */
export const EVENT_DEFINITIONS_COLLECTION = 'eventDefinitions';

/** Documents for individual splat awards (splatId, userId, awardedDate). */
export const AWARDED_SPLATS_COLLECTION = 'awardedSplats';

/** Crawl scheduler: one document per target + crawl type (deterministic id). */
export const CRAWL_SCHEDULES_COLLECTION = 'crawlSchedules';

/** Crawl scheduler: worker execution audit trail. */
export const CRAWL_EXECUTIONS_COLLECTION = 'crawlExecutions';

/** Crawl scheduler dashboard counters (document id `summary`). */
export const SCHEDULER_DASHBOARD_COLLECTION = 'schedulerDashboard';

/** Latest SLO rollup document id (Firestore `schedulerDashboard/sloSnapshot`). */
export const SCHEDULER_SLO_SNAPSHOT_DOC = 'sloSnapshot';

/**
 * Crawl dispatcher: one document per dispatcher run (metrics for dashboard chart).
 * When deploying `firestore.rules`, merge a rule such as the following (Admin SDK writes bypass client rules):
 *
 *   match /crawlDispatcherRuns/{docId} {
 *     allow read: if request.auth != null && request.auth.token.globalAdmin == true;
 *   }
 */
export const CRAWL_DISPATCHER_RUNS_COLLECTION = 'crawlDispatcherRuns';

/**
 * Deterministic crawl planner audit trail (`crawlPlannerRuns`).
 * Readable by global admins; written only by backend (rules deny client writes).
 */
export const CRAWL_PLANNER_RUNS_COLLECTION = 'crawlPlannerRuns';

/** Daily scheduler execution rollups (UTC). Written by `reportSchedulerExecutions`; global-admin read via rules. */
export const SCHEDULER_EXECUTION_REPORTS_COLLECTION = 'schedulerExecutionReports';

/** Daily crawl schedule status rollups (UTC). Written by `reportScheduleStatus`; global-admin read via rules. */
export const SCHEDULER_SCHEDULE_STATUS_REPORTS_COLLECTION = 'schedulerScheduleStatusReports';

/** Monthly splat award rollups (UTC). Written by `reportSplatAwards`; global-admin read via rules. */
export const SPLAT_AWARD_REPORTS_COLLECTION = 'splatAwardReports';

/** Daily registered-user cohort rollups (US Eastern). Written by `reportUserCohorts`; global-admin read via rules. */
export const USER_COHORT_REPORTS_COLLECTION = 'userCohortReports';

/** Daily beer review/check-in rollups by state (US Eastern). Written by `reportBeerActivityByState`. */
export const BEER_ACTIVITY_BY_STATE_REPORTS_COLLECTION = 'beerActivityByStateReports';

/** Latest first-touch signup hotspot rollup. Written by `reportFirstTouch`. */
export const ENGAGE_FIRST_TOUCH_METRICS_COLLECTION = 'engageFirstTouchMetrics';

/** Pending / reviewed beer-duplicate queue documents. */
export const BEER_DUPLICATE_REVIEWS_COLLECTION = 'beerDuplicateReviews';

/**
 * Shadow beer profile versions with embedded live comparison (ITT-969 / ITT-970).
 * globalAdmin read; client write denied in Firestore rules.
 */
export const BEER_PROFILE_VERSIONS_COLLECTION = 'beerProfileVersions';

/** Crawler data-issue documents (`pending`, `investigated`, `resolved`, …). */
export const CRAWLER_FAILURES_COLLECTION = 'crawlerFailures';

/** Newsletter campaign documents (one per send). Written by backend; globalAdmin read. */
export const NEWSLETTER_CAMPAIGNS_COLLECTION = 'newsletterCampaigns';
